import Model from '@/store/model';
import Expressions from './expressions';
import ExpressionsCount from './expressions_count';
import IncraseSkillPoints from './incrase_skill_points';
import TestSummary from './test_summary';
import User from '../user/user';
import UserIslandProgressionItemResponse from '../user/user_island_progression_item_response';
import Advertisement from '../user/advertisement/advertisement';
import SalesPosition from '../user/sales_position';

class EvaluateResponse extends Model {
  map(json) {
    super.map(json);

    if (json.expressions !== undefined && json.expressions !== null) {
      this.mapArray('expressions', json.expressions, Expressions);
    }

    if (json.advertisement !== undefined && json.advertisement !== null) {
      this.advertisement = new Advertisement();
      this.advertisement.map(json.advertisement);
    }

    if (json.expressions_count !== undefined && json.expressions_count !== null) {
      this.expressionsCount = new ExpressionsCount();
      this.expressionsCount.map(json.expressions_count);
    }

    if (json.friends !== undefined && json.friends !== null) {
      this.mapArray('friends', json.friends, User);
    }

    if (json.incrase_skill_points !== undefined && json.incrase_skill_points !== null) {
      this.incraseSkillPoints = new IncraseSkillPoints();
      this.incraseSkillPoints.map(json.incrase_skill_points);
    }

    if (json.test_summary !== undefined && json.test_summary !== null) {
      this.testSummary = new TestSummary();
      this.testSummary.map(json.test_summary);
    }

    if (json.user !== undefined && json.user !== null) {
      this.user = new User();
      this.user.map(json.user);
    }
    if (json.island_completed != null) {
      this.islandCompleted = new UserIslandProgressionItemResponse();
      this.islandCompleted.map(json.island_completed);
    }
    if (json.sales_position !== undefined && json.sales_position !== null) {
      this.salesPosition = new SalesPosition();
      this.salesPosition.map(json.sales_position);
    }
  }
}
export default EvaluateResponse;
